export function getKarmaChangeDateRange() {
  throw new Error('getKarmaChangeDateRange called on the client!');
}

export function getKarmaChangeNextBatchDate() {
  throw new Error('getKarmaChangeNextBatchDate called on the client!');
}

export function getKarmaChanges() {
  throw new Error('getKarmaChanges called on the client!');
}
